
import React from 'react'
import styled from 'styled-components'

import { theme } from '../../constants/theme'

export const Burger = ({ open, setOpen }) => (
  <>
    <StyledBurger open={open} onClick={() => setOpen(!open)}>
      <div />
      <div />
      <div />
    </StyledBurger>
  </>
)

const StyledBurger = styled.div`
    width: 2rem;
    height: 2rem;
    position: absolute;
    z-index: 20;
    left: 10px;
    top: 10px;
    display: none;
    @media (max-width: 1000px) {
        display: flex;
        justify-content: space-around;
        flex-flow: column nowrap;
    }
    div {
    width: 2rem;
    height: 0.25rem;
    background-color: ${theme.colors.blueCommon};
    border-radius: 10px;
    transform-origin: 1px;
    transition: all 0.3s linear;
    &:nth-child(1) {
        transform: ${({ open }) => (open ? 'rotate(45deg)' : 'rotate(0)')};
    }
    &:nth-child(2) {
        transform: ${({ open }) => (open ? 'translateX(-100%)' : 'translateX(0)')};
        opacity: ${({ open }) => (open ? 0 : 1)};
    }
    &:nth-child(3) {
        transform: ${({ open }) => (open ? 'rotate(-45deg)' : 'rotate(0)')};
    }
    }
`
